import Image, { StaticImageData } from 'next/image';

import CardImagePointingRight from '../cta-signup-card/CTAJoinNowCard.component';

const HowItWorksCtaImage: React.FC<{
  mobileImage: StaticImageData | string;
  desktopImage: StaticImageData | string;
  altDesktopImage?: string;
  altMobileImage?: string;
}> = ({ mobileImage, desktopImage, altDesktopImage, altMobileImage }) => (
  <>
    <div className='hidden lg:block'>
      <CardImagePointingRight alt={altDesktopImage} src={desktopImage} className='h-[34rem] w-[34rem]' />
    </div>
    <div className='block lg:hidden'>
      <Image alt={altMobileImage ?? ''} className='object-contain' height={288} src={mobileImage} width={208} />
    </div>
  </>
);

export default HowItWorksCtaImage;
